<script setup lang="ts">
import DepartmentAutoComplete from '@/components/AutoCompletes/DepartmentAutoComplete.vue'
import getOfficesType from "@/types/responses/getOffices"
import FormRow from "@/components/Common/FormRow.vue"
import { computed } from "vue"
import i18n from '@/lang/i18n'

const emit = defineEmits(['update:modelValue'])

type modelValueType = {
  id: number | null,
  operation_office_id: number | null,
  name: string | null
}

type selectedOfficeType = {
  id: number | null
  type: string
  name: string | undefined
  departments: getOfficesType['departments']
}

type officeableType = {
  id: number | null,
  name: string | null,
  type: string | null
}

const props = defineProps<{
  modelValue: modelValueType
  selectedOffice: selectedOfficeType
  selectedOfficeableType: officeableType
  initialItemId: number | null
  errors: string[]
  isDepartment: boolean
}>()

const OPERATION_OFFICE_TYPE = 'OperationOffice'

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

const isOperationOffice = computed(() => {
  return props.selectedOfficeableType.type === OPERATION_OFFICE_TYPE
})

const operationOffices = computed(() => {
  if (!isOperationOffice.value) {
    resetDepartment()
  }
  return props.selectedOffice?.type == OPERATION_OFFICE_TYPE ? [props.selectedOffice] : []
})

function resetDepartment() {
  modelValue.value = { id: null, operation_office_id: null, name: null }
}
</script>
<template>
  <FormRow
    :title="i18n.global.t('pages.common.autocomplete.department')"
    :required="props.isDepartment"
  >
    <DepartmentAutoComplete
      v-model="modelValue"
      :operationOffices="operationOffices"
      :readonly="!isOperationOffice"
      :initialItemId="props.initialItemId"
      :errorMessages="props.errors"
    />
  </FormRow>
</template>
